import { render, staticRenderFns } from "./fullactivities.vue?vue&type=template&id=24057a92&"
import script from "./fullactivities.vue?vue&type=script&lang=js&"
export * from "./fullactivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports